import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import BlogDetail from "components/blogs/GridWithRecentPost";
import { BlogData } from "../assets/blogData";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const GrayLinkBase = tw.a` h-full text-gray-500 font-bold hover:text-primary-500`;
const Post = tw.div` h-full text-primary-500 font-bold inline-block`;
const Content = tw.div`max-w-screen-xl mx-auto pt-8 lg:pt-12`;

export default () => {
  const params = useParams();

  const details = BlogData.popularPosts.filter((item) => {
    return item.id == params.id;
  });

  const data = BlogData.recentPosts.filter((item) => {
    return item.id == params.id;
  });

  return (
    <AnimationRevealPage>
      <Header />
      <Content>
        <GrayLinkBase href={`/`}>Home</GrayLinkBase>
        <span tw="text-gray-500 mx-2"> / </span>
        <GrayLinkBase href={`/blog`}>Blog</GrayLinkBase>
        <span tw="text-gray-500 mx-2"> / </span>
        <Post>Blog Detail</Post>
      </Content>
      <BlogDetail
        postImageSrc={
          (details && details[0]?.postImageSrc) ||
          (data && data[0].postImageSrc)
        }
        authorImageSrc={
          (details && details[0]?.authorImageSrc) ||
          (data && data[0].authorImageSrc)
        }
        title={(details && details[0]?.title) || (data && data[0].title)}
        description={
          (details && details[0]?.description) || (data && data[0].description)
        }
        authorName={
          (details && details[0]?.authorName) || (data && data[0].authorName)
        }
        authorProfile={
          (details && details[0]?.authorProfile) ||
          (data && data[0].authorProfile)
        }
        recentPosts={BlogData?.recentPosts}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
